// FutureLab
import { getUserDisplayName, returnOneToOneChatUserDetails } from '../../../utilities/UserDetails';
import { isSameUserId } from '../../../utilities/UserId';
import { ChatListDataInterface } from '../ChatListItemsMobile';
import { UserDetailsListItem } from '../../../model';
import { LoggedInUserDetails } from '../../../reducers/index';

// 3rd Part
import moment from 'moment';

interface ChatListItemNameAndTimeProps {
	chatListItem: ChatListDataInterface;
	loggedInUserDetails: LoggedInUserDetails;
	userListProfilesDetails: UserDetailsListItem[];
	showTime?: boolean;
}

export function ChatListItemNameAndTime(chatListItemNameProps: ChatListItemNameAndTimeProps) {
	const { chatListItem, loggedInUserDetails, userListProfilesDetails, showTime = true } = chatListItemNameProps;

	const returnFormattedTime = (time: string) => {
		return moment(time).format(moment(time).isSame(moment(), 'day') ? 'h:mma' : 'h:mma, D/M');
	};

	const getGroupChatNameFromParticipantNames = (): string => {
		const groupParticipantIds = chatListItem.participants.map((participant) => participant.userId);
		const userListProfilesFullDetails = userListProfilesDetails.filter((userListProfileDetails) =>
			groupParticipantIds.some((userId) => isSameUserId(userId, userListProfileDetails.id))
		);
		return userListProfilesFullDetails
			.map((user) => user.firstname?.trim())
			.filter(Boolean)
			.join(', ') || 'Unnamed group';
	};

	const getGroupChatName = (chatListItem: ChatListDataInterface): string => {
		const nameFromDb = chatListItem.name?.trim();
		return nameFromDb ? nameFromDb : getGroupChatNameFromParticipantNames();
	};
	const privateChatUser = returnOneToOneChatUserDetails(chatListItem, loggedInUserDetails, userListProfilesDetails);

	return (
		<div className="flex min-w-0 items-center gap-2">
			<div className="min-w-0 flex-1 truncate pb-1 text-sm font-semibold capitalize text-slate-900">
				{chatListItem.isGroupChat
					? getGroupChatName(chatListItem)
					: getUserDisplayName(privateChatUser)}
			</div>
			{showTime && chatListItem?.latestMessageDateTime && (
				<time className="shrink-0 text-right text-xs text-slate-500" dateTime={chatListItem.latestMessageDateTime}>
					{returnFormattedTime(chatListItem.latestMessageDateTime)}
				</time>
			)}
		</div>
	);
}
